import React, { useEffect } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { IonApp, IonLabel, IonRouterOutlet, IonTabs, IonTabBar, IonTabButton, setupConfig } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';

/* Pages */
import Home from './pages/Home';
import Posts from './pages/Posts';
import Profile from './pages/Profile';
import LoginSignup from './pages/LoginSignup';
import Dash from './pages/Dash';
import Submit from './pages/Submit';
import Post from './pages/Post';
import EditProfile from './pages/EditProfile';
import EditPost from './pages/EditPost';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables and styles */
import './theme/variables.css';
import './styles.scss';

/* Redux stuff */
import store from './store';
import { Provider } from 'react-redux';

/* Routing stuff */
import PrivateRoute from './helpers/PrivateRoute';
import PublicRoute from './helpers/PublicRoute';
import setAuthToken from './services/setAuthToken';
import { loadUser } from './actions/authenticationActions';

if (localStorage.token) {
  setAuthToken(localStorage.token);
}

const App = () => {
  // force ios everywhere
  setupConfig({
    mode: 'ios',
  });

  useEffect(() => {
    store.dispatch(loadUser());
  }, []);

  return (
    <Provider store={store}>
      <IonApp>
        <IonReactRouter>
          <IonTabs>
            <IonRouterOutlet>
              <Route path='/' render={() => <Redirect to='/home' />} exact={true} />

              <PublicRoute component={Home} path='/home' restricted={false} exact />
              <PublicRoute component={LoginSignup} path='/login' restricted={true} />
              <PublicRoute component={() => <LoginSignup signup />} path='/register' restricted={true} />

              <PrivateRoute component={Dash} path='/dash' />
              <PrivateRoute component={Posts} path='/posts' />
              <PrivateRoute component={Profile} path='/profile' />
              <PrivateRoute component={EditProfile} path='/profile/edit' />
              <PrivateRoute component={Submit} path='/submit' />
              <PrivateRoute component={Post} path='/post/:id' />
              <PrivateRoute component={EditPost} path='/post/edit/:id' />
            </IonRouterOutlet>

            <IonTabBar slot='top' color='tertiary' style={{ padding: '8px 0' }}>
              <IonTabButton tab='posts' href='/posts'>
                <IonLabel>
                  <strong>
                    <h2>Posts</h2>
                  </strong>
                </IonLabel>
              </IonTabButton>

              <IonTabButton tab='nCode' href={!localStorage.token ? '/home' : '/dash'}>
                <img alt='logo' src='/assets/icon/nCode.svg' height='60' />
              </IonTabButton>

              {!localStorage.token ? (
                <IonTabButton tab='login' href='/login'>
                  <IonLabel>
                    <strong>
                      <h2>Login</h2>
                    </strong>
                  </IonLabel>
                </IonTabButton>
              ) : (
                <IonTabButton tab='profile' href='/profile'>
                  <IonLabel>
                    <strong>
                      <h2>Profile</h2>
                    </strong>
                  </IonLabel>
                </IonTabButton>
              )}
            </IonTabBar>
          </IonTabs>
        </IonReactRouter>
      </IonApp>
    </Provider>
  );
};

export default App;
